module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-13-c4ffe512f1cf9b8fa39aa2a3a36ef345.webp";